const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeerKegOutlineStaggered30X40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 79.342,
    viewBox: "0 0 30 79.342",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-306.01 -161.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.21 161.54v0.39397h14.493c3.4286 12.346 2.5228 25.38-0.0208 38.686h-14.472v0.39397h4.6705l-0.0409 0.14417c-3.5137 12.525-2.5777 25.728 5e-3 39.17l0.0308 0.15959h24.94v-2.2813c-0.11295 0.62959-0.21015 1.2565-0.33075 1.8873h-24.279c-2.5434-13.306-3.4487-26.34-0.02-38.686h24.319c0.12213 0.43979 0.19867 0.88686 0.30993 1.3284v-1.7054l-5e-3 -0.017h5e-3v-0.39397h-9.8068c-2.5434-13.306-3.4487-26.34-0.02-38.686h9.8268v-0.39397h-10.132l-0.0409 0.14417c-3.5137 12.525-2.5777 25.728 5e-3 39.17l0.0308 0.1596h-4.6652l0.0308-0.1596c2.5826-13.442 3.5182-26.645 5e-3 -39.17l-0.0401-0.14417h-10.133zm0 39.491v1.7054c2.8639 11.365 2.1844 23.294 0 35.47v2.2813l0.0308-0.15959c2.5826-13.442 3.5182-26.645 5e-3 -39.17z",
    color: "#000000",
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.065,
    strokeWidth: 0.39474,
    style: {
      InkscapeStroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeerKegOutlineStaggered30X40);
export default __webpack_public_path__ + "static/media/beer-keg-outline-staggered-30-x-40.7b5e41c8dbf771c843ed1e7b45be62a3.svg";
export { ForwardRef as ReactComponent };